const CalculCategorie = (naissance) => {
    naissance = new Date(naissance)

    if(new Date('2011-09-01') < naissance) {
        return "U12"
    } else if(new Date('2007-09-01') < naissance) {
        return "U16"
    } else if(new Date('2003-09-01') < naissance) {
        return "U20"
    } else if(new Date('1978-09-01') < naissance) {
        return "OPEN"
    } else {
        return "VETERAN"
    }
}

export default CalculCategorie
